// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__FNC-d","row":"ProcedureTreatmentSummary_row__hYH9P"};